/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Creativeservicev1AdType } from '../models/Creativeservicev1AdType';
import { Creativeservicev1Status } from '../models/Creativeservicev1Status';
import { Creativeservicev1Type } from '../models/Creativeservicev1Type';
import { HttpFile } from '../http/http';

export class V1CreativeSearch {
    'creativeId'?: string;
    'name'?: string;
    'orgId'?: string;
    'status'?: Creativeservicev1Status;
    'type'?: Creativeservicev1Type;
    'adType'?: Creativeservicev1AdType;
    'folder'?: string;
    'orgName'?: string;
    'orgLogo'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "creativeId",
            "baseName": "creative_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "Creativeservicev1Status",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "Creativeservicev1Type",
            "format": ""
        },
        {
            "name": "adType",
            "baseName": "ad_type",
            "type": "Creativeservicev1AdType",
            "format": ""
        },
        {
            "name": "folder",
            "baseName": "folder",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgName",
            "baseName": "org_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgLogo",
            "baseName": "org_logo",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1CreativeSearch.attributeTypeMap;
    }

    public constructor() {
    }
}

